import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "d-flex align-center mb-4" }
const _hoisted_3 = { class: "d-flex align-center mb-3 gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_DxScheduler = _resolveComponent("DxScheduler")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-h5 font-weight-bold" }, "Cereri Concediu", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_chip, {
        class: "mr-3",
        color: "green",
        variant: "tonal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("mdi-umbrella-beach", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.zileCO) + " zile CO disponibile (" + _toDisplayString(_ctx.anCurent) + ") ", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        color: "red-darken-1",
        "prepend-icon": "mdi-plus",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogCerere = true))
      }, {
        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
          _createTextVNode(" Cerere nouă ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
      color: "red-darken-1",
      class: "mb-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "cereri" }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
            _createTextVNode("Cereri mele", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "calendar" }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createTextVNode("Calendar departament", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "cereri" }, {
          default: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dataSource,
              "show-borders": true,
              "row-alternation-enabled": true,
              "remote-operations": true
            }, {
              stareCellTemplate: _withCtx(({ data }) => [
                _createVNode(_component_v_chip, {
                  color: _ctx.stareColor(data.data.Stare),
                  size: "small",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.stareLabel(data.data.Stare)), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              actiuniCellTemplate: _withCtx(({ data }) => [
                (data.data.Stare === 'in_asteptare')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      icon: "mdi-close",
                      size: "small",
                      color: "red",
                      variant: "text",
                      onClick: ($event: any) => (_ctx.anuleaza(data.data.ID)),
                      title: "Anulează"
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_DxColumn, {
                  "data-field": "DataInceput",
                  caption: "Data start",
                  "data-type": "date",
                  format: "dd.MM.yyyy",
                  width: 120
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "DataSfarsit",
                  caption: "Data sfârșit",
                  "data-type": "date",
                  format: "dd.MM.yyyy",
                  width: 120
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "NumarZile",
                  caption: "Zile",
                  width: 70
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "TipConcediu",
                  caption: "Tip",
                  width: 100
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Descriere",
                  caption: "Descriere"
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Stare",
                  caption: "Stare",
                  width: 130,
                  "cell-template": "stareCellTemplate"
                }),
                _createVNode(_component_DxColumn, {
                  caption: "Acțiuni",
                  width: 100,
                  "cell-template": "actiuniCellTemplate"
                }),
                _createVNode(_component_DxPaging, { "page-size": 15 }),
                _createVNode(_component_DxFilterRow, { visible: true })
              ]),
              _: 1
            }, 8, ["data-source"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "calendar" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_select, {
                modelValue: _ctx.calLuna,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.calLuna) = $event)),
                items: _ctx.luni,
                "item-title": "text",
                "item-value": "val",
                label: "Luna",
                variant: "outlined",
                density: "compact",
                style: {"max-width":"160px"}
              }, null, 8, ["modelValue", "items"]),
              _createVNode(_component_v_select, {
                modelValue: _ctx.calAn,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.calAn) = $event)),
                  _ctx.incarcaCalendar
                ],
                items: _ctx.ani,
                label: "An",
                variant: "outlined",
                density: "compact",
                style: {"max-width":"100px"}
              }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]),
              _createVNode(_component_v_btn, {
                icon: "mdi-refresh",
                variant: "text",
                onClick: _ctx.incarcaCalendar
              }, null, 8, ["onClick"])
            ]),
            _createVNode(_component_DxScheduler, {
              "data-source": _ctx.calendarData,
              "current-date": _ctx.calendarDate,
              views: ['month'],
              "current-view": "month",
              height: 500,
              editing: false,
              "start-date-expr": "DataInceput",
              "end-date-expr": "DataSfarsit",
              "text-expr": "NumeAngajat"
            }, null, 8, ["data-source", "current-date"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogCerere,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialogCerere) = $event)),
      "max-width": "520",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "xl" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "mr-2",
                  color: "red-darken-1"
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("mdi-umbrella-beach", -1)
                  ]))]),
                  _: 1
                }),
                _cache[18] || (_cache[18] = _createTextVNode(" Cerere concediu nouă ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _ctx.cerereValid,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cerereValid) = $event)),
                  ref: "cerereForm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.cerereForm.TipConcediu,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cerereForm.TipConcediu) = $event)),
                      label: "Tip concediu",
                      variant: "outlined",
                      density: "compact",
                      class: "mb-3",
                      rules: [_ctx.required]
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.cerereForm.DataInceput,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cerereForm.DataInceput) = $event)),
                              label: "Data start",
                              type: "date",
                              variant: "outlined",
                              density: "compact",
                              rules: [_ctx.required]
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.cerereForm.DataSfarsit,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cerereForm.DataSfarsit) = $event)),
                              label: "Data sfârșit",
                              type: "date",
                              variant: "outlined",
                              density: "compact",
                              rules: [_ctx.required]
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.cerereForm.Descriere,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cerereForm.Descriere) = $event)),
                      label: "Observații",
                      variant: "outlined",
                      density: "compact",
                      rows: "2",
                      class: "mt-2"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.cerereError)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "error",
                      variant: "tonal",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.cerereError), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogCerere = false))
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "red-darken-1",
                  loading: _ctx.cerereLoading,
                  disabled: !_ctx.cerereValid,
                  onClick: _ctx.submitCerere
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode(" Trimite cerere ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}